import { render } from "./AnnSetTableOptions.vue?vue&type=template&id=0f7fbff8&scoped=true"
import script from "./AnnSetTableOptions.vue?vue&type=script&lang=js"
export * from "./AnnSetTableOptions.vue?vue&type=script&lang=js"

import "../../assets/scss/ann_set_table_options.scss?vue&type=style&index=0&id=0f7fbff8&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7fbff8"]])

export default __exports__